import { useState, useCallback, useEffect } from "react";
import server from "../functions/server";
import Cookies from "js-cookie";

export const useDashboardData = (user) => {
  const [isPuxando, setPuxando] = useState(0);
  const [isPuxandoPed, setPuxandoPed] = useState(0);
  const [isPuxandoEq, setPuxandoEq] = useState(0);
  const [isPuxandoCad, setPuxandoCad] = useState(0);

  const [dadosTitulo, setDadosTitulo] = useState([]);
  const [dadosPedidos, setDadosPedidos] = useState([]);
  const [dadosEquip, setDadosEquip] = useState([]);
  const [dadosCad, setDadosCad] = useState([]);

  const fetchData = useCallback(async (signal) => {
    const baseOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("bearer"),
      },
      body: JSON.stringify({
        jsonid: localStorage.getItem("token"),
        cnpj: user,
      }),
      signal: signal,
    };

    if (isPuxando === 0) {
      setPuxando(1);
      try {
        const response = await fetch(server + "portalCliente/consulta/notas", baseOptions);
        const reqres = await response.json();
        if (reqres.data) setDadosTitulo(JSON.stringify(reqres.data));
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error("Error fetching notas:", error);
        setPuxando(0);
      }
    }

    if (isPuxandoPed === 0) {
      setPuxandoPed(1);
      try {
        const response = await fetch(server + "portalCliente/consulta/pedidos", baseOptions);
        const reqres = await response.json();
        if (reqres.data) setDadosPedidos(JSON.stringify(reqres.data));
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error("Error fetching pedidos:", error);
        setPuxandoPed(0);
      }
    }

    if (isPuxandoEq === 0) {
      setPuxandoEq(1);
      try {
        const response = await fetch(server + "portalCliente/consulta/equipamentos", baseOptions);
        const reqres = await response.json();
        if (reqres.data) {
          setDadosEquip(JSON.stringify(reqres.data));
        } else {
          setPuxandoEq(0);
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error("Error fetching equipamentos:", error);
        setPuxandoEq(0);
      }
    }

    if (isPuxandoCad === 0) {
      setPuxandoCad(1);
      try {
        const response = await fetch(server + "portalCliente/consulta/dados_cad", baseOptions);
        const reqres = await response.json();
        if (reqres.data) {
          setDadosCad(reqres.data);
        } else {
          setPuxandoCad(0);
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error("Error fetching dados_cad:", error);
        setPuxandoCad(0);
      }
    }
  }, [isPuxando, isPuxandoPed, isPuxandoEq, isPuxandoCad, user]);

  useEffect(() => {
    const controller = new AbortController();
    
    fetchData(controller.signal);

    return () => {
      controller.abort();
    };
  }, [fetchData]);

  return {
    isPuxando,
    fetchData,
    dadosTitulo,
    isPuxandoPed,
    dadosPedidos,
    isPuxandoEq,
    dadosEquip,
    isPuxandoCad,
    dadosCad,
  };
};